module.exports = __webpack_public_path__ + "img/alerus-dark.173b8d9d.svg";